import { render, staticRenderFns } from "./HeaderLogoutButton.vue?vue&type=template&id=0a02b0ce"
import script from "./HeaderLogoutButton.vue?vue&type=script&lang=js"
export * from "./HeaderLogoutButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports